import Vue from 'vue/dist/vue.esm'
window.eventBus = new Vue();
